// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control[data-v-4be505a5]:not([type="checkbox"]) {
  line-height: 1.2;
}
`, "",{"version":3,"sources":["webpack://./admin/pages/Tenant/ImportModal.3.vue","webpack://./../ImportModal.3.vue"],"names":[],"mappings":"AACA;EACI,gBAAA;ACAJ","sourcesContent":["\n.form-control:not([type=\"checkbox\"]) {\n    line-height: 1.2;\n}\n",".form-control:not([type=\"checkbox\"]) {\n  line-height: 1.2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
